const URL_PATH = '/cms/api/supported-host/l10n/hosts';

interface Language {
    host: string;
    language: string;
    locale: string;
    label: string;
}

interface Host {
    countryName: string;
    countryCode: string;
    languages: Language[];
}

function addLanguage(map: Record<string, string>, language: Language): Record<string, string> {
    map[language.locale.replace('_', '-').toLowerCase()] = language.host;
    return map;
}

function groupHostsByLocales(hosts: Host[]): Record<string, string> {
    return hosts.flatMap((host) => host.languages).reduce(addLanguage, {});
}

function getHosts(): Promise<Host[]> {
    return fetch(URL_PATH)
        .then((response) => response.json())
        .then((data) => data as Host[])
        .catch(() => []);
}

function getHostsByLocales(): Promise<Record<string, string>> {
    return getHosts().then(groupHostsByLocales);
}

export default function useHosts() {
    return {
        getHostsByLocales,
        getHosts,
    };
}
